import * as React from "react";
import ExitAppProps from "./IProps";
import constantFile from "../../constants/constantFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as draftListActionCreators from "../DraftRegistration/actionCreators";
import { dateTimeFormatter, handleEnter, imagePathurl } from "../../utils//utils";
import * as dynamicFormActionCreators from "../DynamicForm/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import * as URL from "../../../config.json";
import { setCCzPopup, removeWindowBeforeUnload } from "../../utils/utils";
import ReactGA from "react-ga";
interface ExitAppStateProps {
    checked?: any;
}
/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
class ExistApp extends React.Component<ExitAppProps, ExitAppStateProps, {}> {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
        };
        this.closePopUp = this.closePopUp.bind(this);
        this.handleCLick = this.handleCLick.bind(this);
        this.onExistingAppNavigateClick = this.onExistingAppNavigateClick.bind(this);
    }
    closePopUp() {
        this.props.hidePopsUp();
    }
    handleCLick = (e) => {
        this.setState({
            checked: !this.state.checked,
        });
    };
    onExistingAppNavigateClick(data) {
        setCCzPopup(this.state.checked);
        this.props.hidePopsUp();
        document.body.classList.remove("hideOverflow");
        const { formData, formId, warrantyId, isSubmittedForm } = this.props;
        const {
            saveDraftForm,
            updateDraftForm,
            updateBillingAddressStatus,
            validateBuildingAddress,
        } = this.props.dynamicFormActions;

        const cczlink = `${URL["CONFIG"].cczLink}`;
        const successCallBackUpdate = () => {
            removeWindowBeforeUnload();
            window.open(cczlink, "_self");
        };
        const failureCallback = () => {};
        const validateBillAddrcbk = (status) => {
            updateBillingAddressStatus({ payload: status });
            if (status) {
                if (warrantyId) {
                    updateDraftForm({
                        payload: {
                            Id: warrantyId,
                            formData: formData,
                            successCallBack: successCallBackUpdate,
                            failureCallback: failureCallback,
                        },
                    });
                } else {
                    saveDraftForm({
                        payload: {
                            Id: formId,
                            formData: formData,
                            successCallBack: successCallBackUpdate,
                            failureCallback: failureCallback,
                        },
                    });
                }
            } else {
                updateBillingAddressStatus({ payload: status });
                removeWindowBeforeUnload();
                window.open(cczlink, "_self");
            }
        };
        if (isSubmittedForm) {
            successCallBackUpdate();
        } else {
            validateBuildingAddress({ successCallback: validateBillAddrcbk });
        }
    }
    render() {
        const checkBoxVal = this.state.checked;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        return (
            <React.Fragment>
                <div>
                    <div className="overlay" onClick={() => this.closePopUp()}>
                        <div
                            className="popup-container"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                            <div className="close-menu" onClick={() => this.closePopUp()}>
                                <img
                                    tabIndex={2}
                                    onKeyPress={handleEnter}
                                    className="popup-close-icon"
                                    src={`${getimagePath}close-mobile.png`}
                                    alt="close"
                                />
                            </div>
                            {/* <div className="popup-header-title">{constantFile.redirectGenaralTitle}</div> */}
                            <div className="popup-header-subtitle">{constantFile.navigateAwayDescription}</div>
                            <label className={`gaf-dont-show-checkbox  ${checkBoxVal ? "checked" : "unchecked"}`}>
                                <input
                                    checked={this.state.checked}
                                    type="checkbox"
                                    className="hide-checkbox"
                                    onClick={this.handleCLick}
                                />
                            </label>
                            <label className="dontshow">{constantFile.navigateCheckboxText}</label>
                            <div className="text-center">
                                <button
                                    type="button"
                                    tabIndex={2}
                                    id="btn_dashboard"
                                    className="popup-btn"
                                    onClick={this.onExistingAppNavigateClick}
                                >
                                    {constantFile.navigateAwayConfirmButtonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export function mapStateToProps(state) {
    return {
        screenResolution: state.globalInfo.screenResolution,
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        isBuildingAddressAvailable: state.dynamicFormInfo.isBuildingAddressAvailable,
        isSubmittedForm: state.adminData.isSubmittedForm,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExistApp);
